<template>
	<div>
		<div style="margin-bottom: 0.9375rem;">
			<span style="font-size: 0.9375rem; margin: 0 0.9375rem 0.625rem 0;">自动抄表类型</span>
			 <a-radio-group v-model="configType" @change="configTypeChange">
				<a-radio :value="2">每月固定抄表</a-radio>
				<a-radio :value="1">每天固定抄表</a-radio>
			 </a-radio-group>
		</div>
		<div>
			<div style="display: flex; flex-direction: row;">
				<span style="font-size: 0.9375rem; margin: 0 0.9375rem 0.625rem 0;">指定抄表日期</span>
				<a-checkbox :disabled="this.configType == 1" @change="checkDayAll" :indeterminate="indeterminate" :checked="checkAll">全部选择</a-checkbox>
			</div>
			<a-checkbox-group @change="onChange" v-model="checkedDayList" :disabled="this.configType == 1" >
				<a-row>
					 <a-col v-for="(item,index) in dayList.slice(0,10) ":span="3">
						<a-checkbox :value="item">{{item}}</a-checkbox>
					</a-col>
					<a-col v-for="(item,index) in dayList.slice(10,20) ":span="3" >
						<a-checkbox :value="item">{{item}}</a-checkbox>
					</a-col>
					<a-col v-for="(item,index) in dayList.slice(20,31) ":span="3">
						<a-checkbox :value="item">{{item}}</a-checkbox>
					</a-col>
				</a-row>
			</a-checkbox-group>
		 </div>
		 <div style="margin:0.9375rem 0;">
			 <span style="font-size: 0.9375rem;">指定抄表时间</span>
			 <div style="display: flex; flex-direction: row; margin: 0.6rem 0;align-items: center;">
					<span>指定小时：</span>
					<a-select style="width:4.5rem;margin: 0 0.5rem;" v-model="hour">
						<a-select-option v-for="(item,index) in hourList" :key="index">{{item}}</a-select-option>
					</a-select>
					<span>时</span>
			 </div>
			 <div style="display: flex; flex-direction: row; margin: 0.6rem 0;align-items: center;">
					<span>指定分钟：</span>
					<a-select style="width:4.5rem;margin:0 0.5rem;" v-model="minute">
						<a-select-option v-for="(item,index) in minuteList" :key="index">{{item}}</a-select-option>
					</a-select>
					<span>分</span>
			 </div>
			 <div style="margin-top: 1.5rem;">
				 <span style="color:red">配置完成后，集中器将在指定周期内执行抄表操作.</span>
			 </div>
		 </div>
		 <div class="drawerFooter">
		     <a-button  icon="close" @click="onClose" style="margin-right: 0.625rem;">取 消</a-button>
		     <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
			 <a-popconfirm title="确定要删除?" ok-text="确定" cancel-text="取消" placement="topLeft" @confirm="onDelete">
			 		 <a-button style="margin-left: 0.625rem;"  icon="delete"  type="danger" :loading="deleteFlag" v-if="hasFlag">删 除</a-button>
			 </a-popconfirm>
		 </div>
	</div>
</template>

<script>
	export default{
		props:['theObj'],
		data(){
			return{
				checkedDayList:[],
				indeterminate:false,
				checkAll:false,
				submitFlag:false,
				deleteFlag:false,
				hasFlag:false,
				hour:null,
				minute:null,
				configType:2,
				tempResult:null,
			}
				
		},
		methods:{
			configTypeChange:function(e){
				this.configType = e.target.value;
				if(this.configType == 1){
					this.checkAll  = true;
					this.indeterminate = false;
					this.checkedDayList = this.dayList;
				}else{
					if(this.tempResult!=null){
						this.resetResult();
					}else{
						this.checkAll  = false;
						this.indeterminate = false;
						this.checkedDayList = [];
					}
				}
			},
			queryData:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_CONFIG_PERIOD_GET_URL);
				let param = {gprsId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						if(result !=null){
							this.tempResult = result;
							this.hasFlag = true;
							this.resetResult();
						}else{
							this.hasFlag = false;
						}
						
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.deleteFlag = false;
					console.log(error);
				});
			},
			resetResult:function(){
				this.checkedDayList = [];
				let checkDays  = this.tempResult['check_days'];
				let tempList = checkDays.split(",");
				for(var i = 0;i<tempList.length;i++){
					var temp = Number(tempList[i]);
					this.checkedDayList.push(temp);
				}
				this.checkTheAll();
				this.hour = this.tempResult['check_hour'];
				this.minute = this.tempResult['check_minute'];
				this.configType = Number(this.tempResult['config_type']);
			},
			checkDayAll:function(e){
				this.checkAll = e.target.checked,
				this.indeterminate = false;
				this.checkedDayList = e.target.checked ? this.dayList : [];
			},
			onChange:function(values){
				this.checkedDayList = values;
				this.checkTheAll();
			},
			checkTheAll(){
				this.indeterminate = this.checkedDayList.length && this.checkedDayList.length !=this.dayList.length;
				this.checkAll = this.checkedDayList && this.checkedDayList.length == this.dayList.length;
			},
			onClose:function(){
					this.$emit('cancelConfig');
			},
			validIt:function(){
				if(this.checkedDayList .length == 0){
					this.$message.error('请指定抄表日期');
					return false;
				}
				if(this.hour == null){
					this.$message.error('请指定抄表时段');
					return false;
				}
				if(this.minute == null){
					this.$message.error('请指定抄表分钟');
					return false;
				}
				return true;
			},
			onSubmit:function(){
				if(this.validIt()){
					this.submitFlag = true;
					let temp = this.hasFlag ? this.Api.NEIGHBOR_CONFIG_PERIOD_UPDATE_URL : this.Api.NEIGHBOR_CONFIG_PERIOD_ADD_URL;
					let url = this.Api.getLastUrl(temp);
					let param = {
						gprsId:this.theObj.pId,
					    checkDays:this.checkedDayList.join(","),
						checkHour:this.hour,
						checkMinute:this.minute,
						configType:this.configType,
					};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.submitFlag = false;
						let code = data.data.code;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success('配置成功',1);
							this.onClose();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.submitFlag = false;
						console.log(error);
					});
				}
			},
			onDelete:function(){
				this.deleteFlag = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_CONFIG_PERIOD_DELETE_URL);
				let param = {gprsId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.deleteFlag = true;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('删除成功',1);
						this.onClose();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.deleteFlag = false;
					console.log(error);
				});
			}
		},
		computed:{
			dayList:function(){
				 var result= [];
				 for(var  i= 1;i<=31;i++){
					 result.push(i);
				 }
				 return result;
			},
			hourList:function(){
				var result= [];
				for(var  i= 0;i<24;i++){
					result.push(i);
				}
				return result;
			},
			minuteList:function(){
				var result= [];
				for(var  i= 0;i<60;i++){
					result.push(i);
				}
				return result;
			}
		},
		created() {
			this.queryData();
		}
	}
</script>

<style>
</style>
